import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

interface UploadFileWrapperProps {
  hasError: boolean,
  nbPerLine: number,
  noBottomPadding?: boolean,
  bottomPadding?: number
}

export const UploadFileWrapper = styled.div<UploadFileWrapperProps>`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  flex-basis: calc(${(props) => 100 / props.nbPerLine}% - ${(props) => 5 * (props.nbPerLine - 1)}px);

  ${(props) => !props.noBottomPadding && `
    padding-bottom: 17px;
  `};

  ${(props) => props.bottomPadding && `
    padding-bottom: ${props.bottomPadding}px;
  `};

  ${(props) => props.hasError && `
    & .ant-input {
      border-color: ${colors.reddishPink};
    }
  `};

  & > span {
    width: 100%;

    & > div.ant-upload {
      width: 100%;
    }
  }

  & span.ant-upload {
    display: flex;

    & button {
      border-radius: 0 2px 2px 0;
    }
  }

  & .ant-upload-list-text {
    display: none;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    flex-basis: 100%;
  }
`

export const UploadFileName = styled.div`
  font-weight: 600;
  border: 1px solid ${colors.borderBaseColor};
  border-radius: 2px 0 0 2px;
  border-right: none;
  padding-left: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex: 1;
`
export const UploadFileConfirmation = styled.div`
  color: #2DCFB3;
  font-size: 12px;
  margin-top: 6px;
`

export const UploadFileLabel = styled.div`
  line-height: 19px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 11px;
`

export const Required = styled.span `
  color: ${colors.waterBlue};
`
export const ScanFilePreview = styled.div`
 border-radius: 8px;
 .react-pdf__Page__canvas {
  height: 200px;
 }
`

export const UploadPagination = styled.div`
  margin: auto;
  display: block;
  text-align: center;
  padding-bottom: 25px;

  button{
    margin: 0px 10px;
  }
`
